<template>
  <div class="body-ticket">
    <div class="mx-2">
      <div v-if="getTicket">
        <div class="mt-1">
          <b-card class="mb-0 border-bottom">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h2 class="text-uppercase mb-0">
                  {{ getTicket.subject }}
                </h2>

                <small class="text-muted text-uppercase">
                  {{ getTicket.timestamp }}
                </small>
              </div>

              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                @click="refreshTicket(getTicket.id)"
                :disabled="refreshing"
                v-b-tooltip.hover
                title="Actualizar ticket"
              >
                <b-icon-arrow-clockwise
                  :animation="refreshing ? 'spin' : null"
                />
              </button>
            </div>

            <table class="table table-sm">
              <tr>
                <th class="text-nowrap">Ticket:</th>
                <td># {{ getTicket.id }}</td>
              </tr>
              <tr>
                <th>{{ $t("helpdesk.ticket.name") }}:</th>
                <td>{{ getTicket.name }}</td>
              </tr>
              <tr>
                <th>{{ $t("helpdesk.ticket.from") }}:</th>
                <td>{{ getTicket.from }}</td>
              </tr>
              <tr>
                <th>{{ $t("helpdesk.ticket.message") }}:</th>
                <td>{{ getTicket.message }}</td>
              </tr>
              <tr>
                <th>{{ $t("helpdesk.group.title") }}:</th>
                <td>{{ getTicket.group && getTicket.group.length ? getTicket.group[0].name : "" }}</td>
              </tr>
              <tr>
                <th>{{ $t("helpdesk.ticket.type") }}:</th>
                <td>{{ getTicket.ticketType ? getTicket.ticketType.name : "" }}</td>
              </tr>
              <tr>
                <th>{{ $t("helpdesk.ticket.priority") }}:</th>
                <td>{{ priorityTicket }}</td>
              </tr>
              <tr>
                <th>{{ $t("helpdesk.ticket.status") }}:</th>
                <td
                  style="display: flex"
                  v-if="$can('update_status', 'HelpdeskTicket')"
                >
                  <v-select
                    class="mr-2"
                    v-model="statusTicket"
                    :options="statusTicketOptions"
                    :clearable="false"
                    :reduce="(val) => val.value"
                    input-id="role"
                  />
                  <button
                    class="btn btn-sm"
                    @click="updateStatus(getTicket.id)"
                    v-b-tooltip.hover
                    :title="
                      $t('helpdesk.ticket.update') +
                      ' ' +
                      $t('helpdesk.ticket.status')
                    "
                    :disabled="buttonSave"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-save text-dark"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1z"
                      />
                    </svg>
                  </button>
                </td>
                <td v-else>{{ statusTicket }}</td>
              </tr>
            </table>
            <table>
              <tr>
                <th
                  v-for="(a, index) in getTicket.threads[0].attachments"
                  :key="index"
                >
                  <img
                    width="50px"
                    height="50px"
                    class="img-thumbnail"
                    :src="`${urlUvdesk}` + a.relativePath"
                    alt=""
                    @click="openImageModal(`${urlUvdesk}` + a.relativePath)"
                    v-b-modal.image_modal
                  />
                </th>
              </tr>
            </table>
          </b-card>
        </div>
        <div v-for="(t, index) in getTicket.threads" :key="index">
          <b-card v-if="index > 0" class="mb-0 border-bottom">
            <div>
              <p class="badge mb-2 mb-sm-0 badge-dark text-uppercase">
                {{ t.user.name }}
              </p>
              <p class="text-uppercase float-right">{{ t.createdAt }}</p>
            </div>
            <p>{{ t.message }}</p>
            <table class="table table-sm">
              <tr>
                <th v-for="(a, index) in t.attachments" :key="index">
                  <img
                    width="50px"
                    height="50px"
                    class="img-thumbnail"
                    :src="`${urlUvdesk}` + a.relativePath"
                    alt=""
                    @click="openImageModal(`${urlUvdesk}` + a.relativePath)"
                    v-b-modal.image_modal
                  />
                </th>
              </tr>
            </table>
          </b-card>
        </div>
        <validation-observer v-slot="{ handleSubmit }" v-if="$can('create_message', 'HelpdeskTicket')">
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="handleSubmit(onSubmitThread)"
            ref="createThread"
          >
            <validation-provider
              name="message"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('helpdesk.ticket.message')"
                label-for="message"
              >
                <b-form-textarea
                  id="message"
                  v-model="form.message"
                  rows="3"
                  max-rows="6"
                  :state="errors.length > 0 ? false : null"
                ></b-form-textarea>
                <p v-if="errors" class="small text-danger">
                  {{ errors[0] }}
                </p>
              </b-form-group>
            </validation-provider>

            <b-form-group
              class="text-capitalize"
              :label="$t('helpdesk.ticket.attachments')"
              label-for="attachments"
            >
              <vue-dropzone
                id="dropzone_file"
                ref="dropzoneFile"
                :options="dropzoneOptions"
                class="dropzone-file"
                @vdropzone-file-added="addFile"
                @vdropzone-removed-file="removeFile"
              />
            </b-form-group>

            <b-button
              size="sm"
              variant="primary"
              class="mt-1 mb-1 text-capitalize"
              type="submit"
              :disabled="buttonSave"
            >
              <span class="align-middle text-capitalize">
                {{ $t("actions.add") }}
              </span>

              <b-spinner 
                v-if="buttonSave"
                small
                type="grow"
                class="ml-50"
              />
            </b-button>
          </b-form>
        </validation-observer>
      </div>

      <div v-else class="text-center">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BButton,
} from "bootstrap-vue";
import store from "@/store";
import vSelect from "vue-select";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import axios from "@axios";
import { getUserData } from "@/auth/utils";

export default {
  components: {
    BForm,
    BFormGroup,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    formValidation,
    vueDropzone: vue2Dropzone,
  },
  props: {
    ticket: {
      type: Object,
    },
  },
  data() {
    return {
      required,
      email,
      form: {
        name: "",
        userId: "",
        email: "",
        message: "",
        file: [],
      },
      getTicket: null,
      refreshing: false,
      buttonSave: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        paramName: "image",
        autoProcessQueue: false,
        dictDefaultMessage: "",
        addRemoveLinks: true,
        dictRemoveFile: this.$t("actions.delete"),
        maxFilesize: 10,
        acceptedFiles: "image/*",
      },
      urlUvdesk: window.__env.VUE_APP_UVDESK,
      statusTicketOptions: [
        { value: 1, label: "Open" },
        { value: 2, label: "Pending" },
        { value: 3, label: "Resolved" },
        { value: 4, label: "Closed" },
      ],
      statusTicket: "",
    };
  },
  setup() {
    const toast = useToast();
    return {
      toast,
    };
  },
  computed: {
    priorityTicket: function () {
      let priorityTicket = [
        { value: 1, label: "Low" },
        { value: 2, label: "Medium" },
        { value: 3, label: "High" },
        { value: 4, label: "Urgent" },
      ];
      return priorityTicket.find(
        (priority) => priority.value === this.getTicket.priority
      ).label;
    },
  },
  mounted() {
    this.setUserData();

    if (this.ticket.data) {
      this.refreshTicket(this.ticket.data.id);
    }
  },
  methods: {
    setUserData() {
      const userData = getUserData();
      this.form.name = userData.name;
      this.form.userId = userData.id;
      this.form.email = userData.email;
    },
    async refreshTicket(id) {
      this.refreshing = true;
      try {
        const { data } = await axios.get("v1/helpdesk/ticket/" + id);
        this.getTicket = data.data.ticket;
        this.statusTicket = data.data.ticket.status;
      } catch (error) {
        this.toast({
          component: ToastificationContent,
          props: {
            title:
              error.response?.data?.message || "Error al actualizar el ticket",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.refreshing = false;
      }
    },
    onSubmitThread() {
      if (!this.form.name || !this.form.userId || !this.form.email) {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Datos incompletos",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }
      this.buttonSave = true;
      let formData = new FormData();
      formData.append("actAsEmail", this.form.email);
      formData.append("message", this.form.message);
      formData.append("id", this.getTicket.id);

      if (this.form.file.length > 0) {
        this.form.file.forEach((item) => {
          formData.append("attachments[]", item);
        });
      }

      const req = {
        id: this.getTicket.id,
        params: formData,
      };
      store
        .dispatch("helpdesk_ticket/thread", req)
        .then((response) => {
          if (response.success) {
            this.toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });

            this.removeFile();
            this.form.message = "";
            this.buttonSave = false;
            this.refreshTicket(this.getTicket.id);
          } else {
            this.toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((response) => {
          this.buttonSave = false;
          this.toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    addFile(file) {
      this.form.file.push(file);
    },
    removeFile() {
      this.$refs.dropzoneFile.removeAllFiles();
      this.form.file = [];
    },
    async openImageModal(imageUrl) {
      await store.dispatch("image_modal/imageUrl", imageUrl);
    },
    updateStatus(id) {
      this.buttonSave = true;
      let status = this.statusTicketOptions.find(
        (status) => status.value === this.statusTicket
      ).label;
      const req = {
        id: id,
        params: {
          property: "status",
          value: this.statusTicket,
          status: status,
          agent: this.form.name,
        },
      };

      store
        .dispatch("helpdesk_ticket/edit", req)
        .then((response) => {
          if (response.success) {
            this.buttonSave = false;
            store.dispatch("helpdesk_ticket/getAssigned", {assigned: this.form.userId, id_user: this.form.userId});
            this.toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });
          }
        })
        .catch((response) => {
          this.buttonSave = false;
          this.toast(
            {
              component: ToastificationContent,
              props: {
                title: response.response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            },
            {
              timeout: 10000,
            }
          );
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropzone-file {
  height: 30px !important;
  padding: 0px;
  margin: auto;
  border: none;
  display: flex;
  box-shadow: inset 0 0 0 3px #dfdfdf;
}

.body-ticket {
  position: absolute;
  top: 0rem;
  bottom: 0;
  overflow: auto;
  left: 0;
  right: 0;
}
</style>
